import React, {useEffect, useState} from "react";
import "./evidence-submission.scss";
import {useDocumentRequests} from "../../../api/cpl-applicant/useQueryDocumentRequests";
import {useSubmitDocument} from "../../../api/cpl-applicant/useMutateSubmitDocument";
import {useNavigate} from "react-router-dom";
import NavigationTabs from "../../../components/UI/NavigationTabs/NavigationTabs";
import {forbiddenFileTypes} from "../../../constants/strings/forbiddenFileTypes";
import {toast} from "react-toastify";
import Loading from "../../../components/UI/Loading/Loading";
import {useDocumentRequestsByPortfolio} from "../../../api/cpl-applicant/useQueryDocumentByPortfolio";
import EvidenceFile from "./components/EvidenceFile";

interface DocumentRequest {
  id: string;
  title: string;
  notes: string;
  status: string;
  created_at: string;
}

const EvidenceSubmission: React.FC = () => {
  const navigate = useNavigate();
  const [uploadedFiles, setUploadedFiles] = useState<Record<string, File>>({});
  const [selectedPortfolio, setSelectedPortfolio] = useState<string>('');

  const {data} = useDocumentRequests();
  const {data: allDocumentRequests = [], isPending} = useDocumentRequestsByPortfolio(selectedPortfolio);
  const {mutateAsync: submitDocument, isPending: submitDocumentPending} = useSubmitDocument();

  // filter out withdrawn requests
  const documentRequests = allDocumentRequests.filter(
    (doc: any) => doc.status === "Request sent"
  );

  useEffect(() => {
    if (data && data?.portfolios?.length > 0) {
      setSelectedPortfolio(data?.portfolios[0].portfolio_id);
    }
  }, [data])

  const handleFileUpload = (documentId: string, file: File) => {
    if (forbiddenFileTypes.find((item: string) => file.name.includes(item))) {
      toast.error('Wrong file format.');
      return;
    }
    setUploadedFiles(prev => ({
      ...prev,
      [documentId]: file
    }));
  };

  const handleSubmit = async (docId: string) => {
    try {
      await submitDocument({
        document_request_id: docId,
        file: uploadedFiles[docId],
      });
    } catch (error) {
      console.error('Error submitting document:', error);
    }
  };

  if (documentRequests.length === 0 && !isPending) {
    return (
      <div className="evidence-submission">
        <div className="evidence-submission-message">
          No document requests found
        </div>
      </div>
    );
  }

  return (
    <div className="evidence-submission">
      <Loading loading={submitDocumentPending}/>
      <div className="evidence-submission-title">Evidence Submission</div>
      <div className="evidence-submission-content">
        <NavigationTabs
          tabs={data
            ? data.portfolios
              .filter((item: any) => item.unresolved_document_requests > 0)
              .map((item: any, index: number) => ({
              name: `Submission ${index + 1}`,
              active: item.portfolio_id === selectedPortfolio,
              onClick: () => setSelectedPortfolio(item.portfolio_id)
            }))
            : []
          }
        />
        <div className={'evidence-submission-content-title'}>
          Requested Documents
        </div>
        <div>
          {
            documentRequests.map((doc: DocumentRequest) =>
              <EvidenceFile
                onFileUploaded={(file) => handleFileUpload(doc.id, file)}
                title={doc.title}
                file={uploadedFiles[doc.id]}
                additionalNote={doc.notes}
                onSubmit={() => handleSubmit(doc.id)}
              />
            )
          }
        </div>
      </div>
    </div>
  );
};

export default EvidenceSubmission;